export default {
  title: 'Interlocutores',
  contactsView: {
    deleteTitle: 'Lista de interlocutores para excluir',
    success: 'Os interlocutores foram excluídos com sucesso.'
  },
  contact: {
    new: 'Novo interlocutor',
    data: 'Introduza os dados do novo interlocutor',
    add: 'Incluir na agenda'
  },
  table: {
    saveNew: 'Guardar como novo elemento',
    createAndSelect: 'Criar e selecionar',
    updateAndSelect: 'Atualizar e selecionar',
    undo: 'Desfazer alterações',
    select: 'Selecionar',
    noResults: 'Nenhum resultado encontrado',
    document: 'NIF/CIF/NIE',
    reason: 'Razão Social/Nome',
    nameSurname: 'Nome Comercial/Sobrenome',
    department: 'Destinatário',
    departmentCode: 'Departamento',
    managerbodyCode: 'Órgão gestor',
    managerbodyDescription: 'Descrição Org. Gestor',
    receiverCode: 'Código destinatário',
    costCenter: 'Centro de custo'
  },
  searchContact: {
    title: 'Agenda',
    search: 'Buscar na agenda',
    showing: 'Mostrando',
    document: 'NIF/CIF/NIE',
    reason: 'Razão Social/Nome',
    nameSurname: 'Nome Comercial/Sobrenome',
    more: 'Ver mais',
    addSelected: 'Adicionar selecionado',
    allContacts: 'Todos os contatos',
    bankiaContacts: 'Contatos do Bankia',
    deleteTitle: 'Excluir interlocutores selecionados',
    deleteConfirm: 'Tem certeza de que deseja excluir os interlocutores selecionados?',
    department: 'Destinatário',
    managerbodyCode: 'Órgão gestor',
    managerbodyDescription: 'Descrição Org. Gestor',
    receiverCode: 'Código destinatário'
  },
  button: {
    newElement: 'Novo elemento'
  }
}